"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUiToggle = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("..");
function useUiToggle(items) {
    var _a;
    const [value, setValue] = react_1.useState((_a = items[0]) === null || _a === void 0 ? void 0 : _a.value);
    return {
        value,
        setValue,
        component: react_1.default.createElement(__1.UiToggle, { value: value, onChangeValue: setValue, items: items }),
    };
}
exports.useUiToggle = useUiToggle;
